import React, { ElementType } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { LocationDescriptor } from 'history';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';
import { PartnerContent, partnerValue } from 'packages/smart-home-support/partner';
import { useUser } from '../../hooks';
import {
  BackButton,
  HeaderMenu,
  HeaderWrapper,
  HeaderContainer,
  HeaderLogoLink,
  SignUpButtonContainer,
  SwapContainer,
  MenuToggler,
} from './components';
import { ctaProps, LinkId } from '../../constants';
import { PAGE_SCROLL_THRESHOLD } from './constants';

export type HeaderProps = {
  toggleMenu: Function;
  closeMenu: Function;
  isMenuOpen: boolean;
  isSticky: boolean;
  isNavigable: boolean;
  isLogoLinked: boolean;
  hasSignupButton?: boolean;
  backTo?: LocationDescriptor;
  pageScrollPosition: number;
  path: string;
  isAuthEnabled: boolean;
};

const SignUpButton = getPartnerAsset<ElementType>(DynamicAssetsKeys.headerMobileCtaComponent);

const Logo = styled.img`
  height: auto;
  max-height: 70%;
  width: auto;
  max-width: 100%;
`;

const DynamicLogo: React.FC<any> = ({ isLogoLinked, closeMenu, isSignupButtonVisible }) => (
  <HeaderLogoLink
    id={LinkId.HeaderMenuHome}
    to={isLogoLinked && '/'}
    onClick={isLogoLinked && closeMenu}
    isVisible={!isSignupButtonVisible}
  >
    <Logo
      src={partnerValue({
        Asurion: require('./resources/ahp-logo.svg'),
        Sprint: require('./resources/sprint-logo.svg'),
        Verizon: require('./resources/shs-logo.svg'),
        TechCoachHome: require('./resources/tech-coach-home-logo.svg'),
      })}
    />
  </HeaderLogoLink>
);

const Header = (props: HeaderProps) => {
  const user = useUser();
  const hasSignupButton = props.hasSignupButton !== false;
  const isPastScrollThreshold = props.pageScrollPosition >= PAGE_SCROLL_THRESHOLD;
  const canShowSignupButton = hasSignupButton && props.isNavigable && !user;
  const isSignupButtonVisible = partnerValue(
    { TechCoachHome: false, Verizon: false },
    !props.isMenuOpen && canShowSignupButton && isPastScrollThreshold
  );

  const history = useHistory();
  const goBack = () => {
    if (history.length) {
      history.goBack();
    } else {
      history.push(props.backTo as string);
    }
  };

  return (
    <>
      <HeaderWrapper isSticky={props.isSticky}>
        <HeaderContainer>
          <BackButton isVisible={Boolean(props.backTo)} onClick={goBack} />
          <SwapContainer>
            <DynamicLogo
              isLogoLinked={props.isLogoLinked}
              closeMenu={props.closeMenu}
              isSignupButtonVisible={isSignupButtonVisible}
            />
            <PartnerContent TechCoachHome="">
              <SignUpButtonContainer isVisible={isSignupButtonVisible} isSticky={props.isSticky}>
                {canShowSignupButton && <SignUpButton id="header-sign-up-button" {...ctaProps} />}
              </SignUpButtonContainer>
            </PartnerContent>
          </SwapContainer>
          {props.isNavigable && <MenuToggler isOpen={props.isMenuOpen} onClick={() => props.toggleMenu()} />}
        </HeaderContainer>
        {props.isNavigable && (
          <HeaderMenu
            isOpen={props.isMenuOpen}
            onClose={props.closeMenu}
            hasSignupButton={hasSignupButton}
            path={props.path}
            isAuthEnabled={props.isAuthEnabled}
            user={user}
          />
        )}
      </HeaderWrapper>
    </>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/Header.tsx